// Attribution & Funnel (Phase 2). Four blocks:
//   - source table: every prospect by source, observed win rates, won $
//   - full funnel: GA4 top (sessions/signups/calls) + CRM bottom
//   - GA4 channel split with the derived AI-assistants channel
//   - top landing pages
// GA4 data follows the top-bar range control; CRM funnel rows cover the
// same date window.

import { useMarketing } from '../MarketingContext';
import SourceTableCard from '../attribution/SourceTableCard';
import FunnelCard from '../attribution/FunnelCard';
import ChannelSplitCard from '../attribution/ChannelSplitCard';
import LandingPagesCard from '../attribution/LandingPagesCard';

export default function AttributionView() {
  const { traffic } = useMarketing();

  return (
    <div className="flex flex-col gap-4">
      <SourceTableCard />
      <FunnelCard />
      <div className="flex flex-col lg:flex-row gap-4 items-stretch">
        <ChannelSplitCard traffic={traffic} maxRows={8} />
        <div className="flex-1 min-w-0">
          <LandingPagesCard traffic={traffic} />
        </div>
      </div>
    </div>
  );
}
